/* eslint-disable import/no-cycle */
import type React from 'react';

import * as styles from './styles';
import { DEFAULT_TIME_SELECTION } from './TimeFilter';

import type { DateRange } from '@cobliteam/common-types';

import {
  CaptionDefault,
  type CloseOverlayHandler,
  ContainerDefault,
  Divider,
  TimeRangeSlider,
} from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

export interface TimeFilterOverlayProps {
  timeSelection: DateRange;
  selectionChanged: boolean;
  sliderMinValue: number;
  sliderMaxValue: number;
  sliderLeftValue: number;
  sliderRightValue: number;
  minInterval: number;
  step: number;
  overlayTitle?: string;
  onTimeSelection: (timeSelection: DateRange) => void;
  onClearFilter: () => void;
  onApplyFilter: () => void;
  onCancel: () => void;
  closeOverlayHandler: CloseOverlayHandler;
}

export const TimeFilterOverlay: React.FC<TimeFilterOverlayProps> = ({
  timeSelection,
  overlayTitle,
  selectionChanged,
  sliderMinValue,
  sliderMaxValue,
  sliderLeftValue,
  sliderRightValue,
  minInterval,
  step,
  ...props
}) => {
  const renderClearFilter = () => (
    <>
      <Button
        variant="text"
        disabled={timeSelection === DEFAULT_TIME_SELECTION}
        className={styles.clearFilterButton}
        onClick={props.onClearFilter}
      >
        Limpar filtros
      </Button>
      <Divider />
    </>
  );

  const renderOptions = () => (
    <div className={styles.optionsContainer}>
      <TimeRangeSlider
        handleChange={(start, end) => props.onTimeSelection({ start, end })}
        step={step}
        minInterval={minInterval}
        leftValue={sliderLeftValue}
        rightValue={sliderRightValue}
        leftLimit={sliderMinValue}
        rightLimit={sliderMaxValue}
      />
    </div>
  );

  const renderActionButtons = () => (
    <>
      <Divider />
      <div className={styles.filterActions}>
        <Button
          variant="text"
          className={styles.cancelButton}
          onClick={props.closeOverlayHandler}
        >
          Cancelar
        </Button>
        <Button
          size="condensed"
          disabled={!selectionChanged}
          onClick={props.onApplyFilter}
        >
          Aplicar
        </Button>
      </div>
    </>
  );

  return (
    <ContainerDefault className={styles.overlay}>
      {renderClearFilter()}

      <div className={styles.optionsContainerScroll()}>
        {overlayTitle && (
          <CaptionDefault className={styles.overlayTitle}>
            {overlayTitle}
          </CaptionDefault>
        )}
        {renderOptions()}
      </div>

      {renderActionButtons()}
    </ContainerDefault>
  );
};
